let currentExploringSlide = 0;
const exploringSlides = document.querySelectorAll('.keep-exploring-slide');
let exploringSlidesToShow = window.innerWidth >= 1025 ? 4 : window.innerWidth >= 768 ? 3 : 2;
let totalExploringPages = Math.ceil(exploringSlides.length / exploringSlidesToShow);

window.addEventListener('resize', () => {
    exploringSlidesToShow = window.innerWidth >= 1025 ? 4 : window.innerWidth >= 768 ? 3 : 2;
    totalExploringPages = Math.ceil(exploringSlides.length / exploringSlidesToShow);
    createIndicators();
    updateSlider();
    updateIndicators();
});

function moveSlide(direction) {
    if (direction === -1 && currentExploringSlide > 0) {
        currentExploringSlide -= exploringSlidesToShow;
    } else if (direction === 1 && currentExploringSlide + exploringSlidesToShow < exploringSlides.length) {
        currentExploringSlide += exploringSlidesToShow;
    }
    updateSlider();
    updateIndicators();
}

function updateSlider() {
    currentExploringSlide = Math.max(0, Math.min(currentExploringSlide, exploringSlides.length - exploringSlidesToShow));
    const slider = document.querySelector('.keep-exploring-slider');
    const slideWidth = 100 / exploringSlidesToShow;
    slider.style.transform = `translateX(-${currentExploringSlide * slideWidth}%)`;

    // Update button visibility based on slide position
    const prevButton = document.querySelector('.keep-exploring-prev');
    const nextButton = document.querySelector('.keep-exploring-next');
    if ( window.innerWidth >= 768 ) {
        prevButton.style.display = currentExploringSlide > 0 ? 'block' : 'none';
        nextButton.style.display = (currentExploringSlide + exploringSlidesToShow) < exploringSlides.length ? 'block' : 'none';
    }
    if ( window.innerWidth < 768 ) {
        prevButton.style.display = 'none';
        nextButton.style.display = 'none';
    }
}

function createIndicators() {
    const indicatorContainer = document.querySelector('.keep-exploring-indicators');
    indicatorContainer.innerHTML = '';
    for (let i = 0; i < totalExploringPages; i++) {
        const indicator = document.createElement('div');
        indicator.classList.add('keep-exploring-indicator');
        indicator.addEventListener('click', () => goToPage(i));
        indicatorContainer.appendChild(indicator);
    }
}

function updateIndicators() {
    const indicators = document.querySelectorAll('.keep-exploring-indicator');
    const currentPage = Math.ceil(currentExploringSlide / exploringSlidesToShow);
    indicators.forEach((indicator, index) => {
        if (index === currentPage) {
            indicator.classList.add('keep-exploring-indicator-active');
        } else {
            indicator.classList.remove('keep-exploring-indicator-active');
        }
    });
}

function goToPage(page) {
    currentExploringSlide = page * exploringSlidesToShow;
    updateSlider();
    updateIndicators();
}

// Initialize slider and indicators on page load
document.addEventListener('DOMContentLoaded', () => {
    createIndicators();
    updateSlider();
    updateIndicators();
});
